const project = {
    namespaced: true,
    state: {
        list: [],
        totalCount: 0,
        pageSize: 10,
        currentPage: 1,
        projectInfo: {},
        projects: []
    },
    mutations: {
        setPageSize(state, size) {
            state.pageSize = size;
        },
        setCurrentPage(state, page) {
            state.currentPage = page;
        }
    },
    actions: {
        async getAll({state}, payload) {
            let page = {
                name: payload.data.name,
                cityName: payload.data.cityName,
                maxResultCount: state.pageSize,
                skipCount: (state.currentPage - 1) * state.pageSize
            };
            let rep = await abp.ajax.post('/api/services/app/Project/SearchProjects', page);
            state.list = [];
            state.list.push(...rep.data.result.items);
            state.totalCount = rep.data.result.totalCount;
        },
        async GetProjectById({state}, payload) {
            let rep = await abp.ajax.get('/api/services/app/Project/GetProjectById?id=' + payload.id);
            state.projectInfo = {};
            state.projectInfo = rep.data.result;
        },
        async delProject({state}, payload) {
            await abp.ajax.delete('/api/services/app/Project/DeleteProjectById?id=' + payload.id);
        },
        async saveProject({state}, payload) {
            await abp.ajax.post('/api/services/app/Project/SaveProject', payload.data);
        },
        async getProjects({state}, payload) {
            var page = {
                maxResultCount: 20,
                skipCount: 0
            };
            if (payload.data && payload.data.cityId != undefined) {
                page.cityId = payload.data.cityId;
            }
            let rep = await abp.ajax.post('/api/services/app/Project/SearchProjects', page);
            state.projects = [];
            state.projects.push(...rep.data.result.items);
            // state.totalCount = rep.data.result.totalCount;
        }
    }
};
export default project;
